import { makeStyles } from '@material-ui/core';

export const styles = makeStyles(() => ({
  promotion: {
    marginLeft: '0',
    marginRight: '2%',
    marginTop: '2%',
    marginBottom: '2%',
  },
  coupon: {
    paddingRight: '1vw',
  },
  tenderIcon: {
    alignSelf: 'flex-start',
    height: '3.1vh',
    width: '3.1vh',
  },
  tenderIconCustomerDisplay: {
    alignSelf: 'flex-start',
    height: '3.1vh',
    width: '1.75vh',
  },
  tenderIconGrid: {
    marginRight: '0.87vw',
  },
}));
